import React, { useState, useEffect, useCallback } from 'react';
import { auditoriaGeneralAPI, authAPI } from '../services/api';
import { useNavigate } from 'react-router-dom';

const ENTIDADES = ['', 'sesion', 'cliente', 'cita', 'factura', 'usuario', 'documento'];
const ACCIONES = ['', 'login', 'logout', 'crear', 'actualizar', 'eliminar'];

const accionBadge = (accion) => {
  const map = {
    login: { bg: '#d4edda', color: '#155724' },
    logout: { bg: '#e2e3e5', color: '#383d41' },
    crear: { bg: '#cce5ff', color: '#004085' },
    actualizar: { bg: '#fff3cd', color: '#856404' },
    eliminar: { bg: '#f8d7da', color: '#721c24' },
  };
  return map[accion] || { bg: '#e9ecef', color: '#495057' };
};

function AuditoriaGeneral() {
  const navigate = useNavigate();
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [filters, setFilters] = useState({ entidad: '', accion: '', fecha_desde: '', fecha_hasta: '' });
  const limit = 50;

  useEffect(() => {
    authAPI.check().then(r => {
      if (r.data?.user?.rol !== 'admin') navigate('/', { replace: true });
    }).catch(() => navigate('/'));
  }, [navigate]);

  const loadLogs = useCallback(async () => {
    setLoading(true);
    try {
      const params = { limit, offset: page * limit };
      if (filters.entidad) params.entidad = filters.entidad;
      if (filters.accion) params.accion = filters.accion;
      if (filters.fecha_desde) params.fecha_desde = filters.fecha_desde;
      if (filters.fecha_hasta) params.fecha_hasta = filters.fecha_hasta;
      const r = await auditoriaGeneralAPI.getAll(params);
      setLogs(r.data?.data || []);
      setTotal(r.data?.total || 0);
    } catch {
      setLogs([]);
    } finally {
      setLoading(false);
    }
  }, [page, filters]);

  useEffect(() => { loadLogs(); }, [loadLogs]);

  const totalPages = Math.ceil(total / limit);

  return (
    <div style={{ padding: '20px', maxWidth: 1100, margin: '0 auto' }}>
      <h2 style={{ marginBottom: 16 }}>Auditoría General</h2>
      <p style={{ color: '#666', marginBottom: 20 }}>Registro de acciones realizadas en el sistema.</p>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginBottom: 20, alignItems: 'flex-end' }}>
        <div>
          <label style={{ fontSize: 12, display: 'block', marginBottom: 4, fontWeight: 600 }}>Entidad</label>
          <select value={filters.entidad} onChange={e => { setFilters(f => ({ ...f, entidad: e.target.value })); setPage(0); }}
            style={{ padding: '6px 10px', borderRadius: 4, border: '1px solid #ccc', fontSize: 13 }}>
            <option value="">Todas</option>
            {ENTIDADES.filter(Boolean).map(e => <option key={e} value={e}>{e}</option>)}
          </select>
        </div>
        <div>
          <label style={{ fontSize: 12, display: 'block', marginBottom: 4, fontWeight: 600 }}>Acción</label>
          <select value={filters.accion} onChange={e => { setFilters(f => ({ ...f, accion: e.target.value })); setPage(0); }}
            style={{ padding: '6px 10px', borderRadius: 4, border: '1px solid #ccc', fontSize: 13 }}>
            <option value="">Todas</option>
            {ACCIONES.filter(Boolean).map(a => <option key={a} value={a}>{a}</option>)}
          </select>
        </div>
        <div>
          <label style={{ fontSize: 12, display: 'block', marginBottom: 4, fontWeight: 600 }}>Desde</label>
          <input type="date" value={filters.fecha_desde} onChange={e => { setFilters(f => ({ ...f, fecha_desde: e.target.value })); setPage(0); }}
            style={{ padding: '6px 10px', borderRadius: 4, border: '1px solid #ccc', fontSize: 13 }} />
        </div>
        <div>
          <label style={{ fontSize: 12, display: 'block', marginBottom: 4, fontWeight: 600 }}>Hasta</label>
          <input type="date" value={filters.fecha_hasta} onChange={e => { setFilters(f => ({ ...f, fecha_hasta: e.target.value })); setPage(0); }}
            style={{ padding: '6px 10px', borderRadius: 4, border: '1px solid #ccc', fontSize: 13 }} />
        </div>
        <button className="btn btn-secondary btn-sm" onClick={() => { setFilters({ entidad: '', accion: '', fecha_desde: '', fecha_hasta: '' }); setPage(0); }}>
          Limpiar
        </button>
      </div>

      {loading ? <p>Cargando...</p> : (
        <>
          <div style={{ overflowX: 'auto' }}>
            <table className="table" style={{ width: '100%', fontSize: 13 }}>
              <thead>
                <tr style={{ background: '#f0f2f5' }}>
                  <th style={{ padding: '8px 12px' }}>Fecha</th>
                  <th style={{ padding: '8px 12px' }}>Usuario</th>
                  <th style={{ padding: '8px 12px' }}>Acción</th>
                  <th style={{ padding: '8px 12px' }}>Entidad</th>
                  <th style={{ padding: '8px 12px' }}>ID</th>
                  <th style={{ padding: '8px 12px' }}>Detalle</th>
                  <th style={{ padding: '8px 12px' }}>IP</th>
                </tr>
              </thead>
              <tbody>
                {logs.length === 0 ? (
                  <tr><td colSpan={7} style={{ textAlign: 'center', padding: 20, color: '#888' }}>No hay registros</td></tr>
                ) : logs.map(log => {
                  const badge = accionBadge(log.accion);
                  return (
                    <tr key={log.id} style={{ borderBottom: '1px solid #eee' }}>
                      <td style={{ padding: '6px 12px', whiteSpace: 'nowrap' }}>
                        {new Date(log.creado_en).toLocaleString('es-ES', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' })}
                      </td>
                      <td style={{ padding: '6px 12px' }}>{log.usuario_nombre || `#${log.usuario_id}`}</td>
                      <td style={{ padding: '6px 12px' }}>
                        <span style={{ display: 'inline-block', padding: '2px 8px', borderRadius: 10, fontSize: 11, fontWeight: 600, background: badge.bg, color: badge.color }}>
                          {log.accion}
                        </span>
                      </td>
                      <td style={{ padding: '6px 12px' }}>{log.entidad}</td>
                      <td style={{ padding: '6px 12px', color: '#888' }}>{log.entidad_id || '—'}</td>
                      <td style={{ padding: '6px 12px', maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={log.detalle}>{log.detalle || '—'}</td>
                      <td style={{ padding: '6px 12px', fontSize: 11, color: '#999', fontFamily: 'monospace' }}>{log.ip || '—'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {totalPages > 1 && (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12, marginTop: 16 }}>
              <button className="btn btn-secondary btn-sm" disabled={page === 0} onClick={() => setPage(p => p - 1)}>← Anterior</button>
              <span style={{ fontSize: 13, color: '#666' }}>Página {page + 1} de {totalPages} ({total} registros)</span>
              <button className="btn btn-secondary btn-sm" disabled={page >= totalPages - 1} onClick={() => setPage(p => p + 1)}>Siguiente →</button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default AuditoriaGeneral;
